/**
 * Dev Mail - Create Command
 * Create a new temp email account
 */
import { Command } from 'commander';
import chalk from 'chalk';
import { ConfigService } from '../../../services/config.service.js';
import { TempMailApiService } from '../../../services/temp-mail.service.js';

interface CreateOptions {
    name?: string;
    json?: boolean;
}

async function handleCreate(options: CreateOptions): Promise<void> {
    const config = await new ConfigService().load();
    if (!config) {
        console.error('❌ Not initialized. Run "jai1 auth" first.');
        process.exit(1);
    }

    const api = new TempMailApiService(config);

    if (!options.json) {
        console.log(chalk.dim('⏳ Creating temp email account...'));
    }

    const result = await api.createAccount(options.name);

    if (!result.success) {
        if (options.json) {
            console.log(JSON.stringify({ success: false, error: result.error }));
        } else {
            console.error(`❌ ${result.error}`);
        }
        process.exit(1);
    }

    if (options.json) {
        console.log(JSON.stringify({ success: true, data: result.data }));
        return;
    }

    console.log();
    console.log(`✅ Temp email created!`);
    console.log(`   ${chalk.bold.cyan(result.data!.address)}`);
    console.log(chalk.dim(`   Created: ${new Date(result.data!.created_at).toLocaleString()}`));
    console.log();
    console.log(chalk.dim('  Run `j dev mail watch <address>` to listen for new emails'));
}

export function createMailCreateCommand(): Command {
    return new Command('create')
        .description('Tạo temp email account mới')
        .option('--name <prefix>', 'Custom prefix cho địa chỉ email')
        .option('-j, --json', 'Output dạng JSON')
        .addHelpText('after', `
Examples:
  $ j dev mail create
  $ j dev mail create --name test
  $ j dev mail create -j
`)
        .action(async (options: CreateOptions) => {
            await handleCreate(options);
        });
}
